<!--
lc-export-button
用例：
<lc-export-button report="products" post-api="/backend/v2/products/export" :extra-param="tabParams" :records-count="apiData.count"></lc-export-button>

最终会在 layouts/Management 监听导出的结果，并且下载文件
//-->
<template>
  <el-button
    :loading="loading"
    :disabled="recordsCount === 0 || disabled"
    class="lc-export-button"
    type="primary"
    icon="el-icon-download"
    @click="handleExportReport"
    >{{ btnText }}<span v-if="seconds"> {{ seconds }}s</span></el-button
  >
</template>

<script>
import { ExportDoneEvent, MaxExportCount, ExportExportingEvent } from '@/constants/global_variables'
import axios from '@/helpers/axios'

export default {
  props: {
    /**
     * 自定义导出按钮文本，不传就是用默认的「导出」
     */
    text: {
      type: String,
      default() {
        return this.$t('common.btn.export')
      }
    },
    /**
     * 报表ID。同类型的report导出有限制
     * 如：orders, ev_charging_stations
     */
    report: {
      type: String,
      default: null
    },
    /**
     * 记录数，主要用作导出上限的提示
     */
    recordsCount: {
      type: Number,
      default: 0
    },
    /**
     * 导出的API
     * 例子：/v2/products/export
     */
    postApi: {
      type: String,
      default: ''
    },
    /**
     * 导出需要增加的参数，适用于子标签页中的列表
     * 如用户详情页/充电包模板详情页中的充电包列表，指定的 用户ID/充电包模板ID 无法从query中获取，需要手动补充
     * 例子：{ user: uuid }
     */
    extraParam: {
      type: Object,
      default: () => null
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      btnText: this.text,
      timeInterval: null, // 导出的倒数计时
      seconds: null
    }
  },
  created() {
    // 收听 management（作为 bus 总线）的信息
    // management 通知已完成下载，按钮释放状态
    management.$on(ExportDoneEvent, this._resetButtonStatus)

    // management 通知下载中，按钮释放状态
    management.$on(ExportExportingEvent, this._handleExportingEvent)
  },
  destroyed() {
    management.$off(ExportDoneEvent, this._resetButtonStatus)
    management.$off(ExportExportingEvent, this._handleExportingEvent)
  },
  methods: {
    /**
     * 重置按钮状态
     *
     * @param {string} report 报表名
     */
    _resetButtonStatus(report) {
      if (report === this.report) {
        this.loading = false
        this.btnText = this.text
      }
    },
    /**
     * 显示进行中的进度
     *
     * @param {object} message 收到的信息
     * @param {string} message.report 报表的类型。如 orders
     * @param {string} message.percentage 导出的进度。如 15
     */
    _handleExportingEvent({ report, percentage }) {
      if (report !== this.report) {
        // 判断是否当前导出的按钮
        return
      }

      if (percentage <= 1 && this.loading === true) {
        console.log('Export percentage: ', percentage)
        // 如果进度未完成，则拼接到按钮上
        this.btnText = this.$t('common.is_exporting') + `${parseInt(percentage * 100)}%`
      }
    },
    /**
     * 发起导出报表的请求
     */
    async handleExportReport() {
      // 检测
      if (this.recordsCount > MaxExportCount) {
        this.$toast.warn(this.$t('common.data_much', [MaxExportCount]))
        return
      }

      // 检测当前报表的状态
      let exportStatusResp = await axios.get('/backend/export_files/status', { params: { type: this.report } })
      if (exportStatusResp.data.status !== 'idle') {
        this.$toast.warn(this.$t('导出过于频繁，请稍后再尝试'))
        return
      }

      this.loading = true // 按钮加载中

      // 创建导出的参数，并在当前标签页记录该请求
      let query = Object.assign({ records_count: this.recordsCount }, this.extraParam, this.$route.query)
      let params = this.buildExportParams(this.report, query)

      this.btnText = this.$t('common.is_exporting')
      axios.post(this.postApi, params)
    }
  }
}
</script>
